import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72463173"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-selects" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]

import { toRefs } from 'vue'

  import { TPaginationPayload } from '@/types/api'

  interface Props {
    order_by: string[]
    query: TPaginationPayload
    sort: string[]
    message: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    order_by: null,
    query: null,
    sort: null,
    message: null
  },
  emits: ['updateSelect'],
  setup(__props: any, { emit }) {

const props = __props as {
    order_by: string[]
    query: TPaginationPayload
    sort: string[]
    message: string
  }

  

  

  const { order_by, query, sort, message } = toRefs(props)
  const perPage = [10, 25, 50, 100]

  function onSelectUpdate(event: Event & { target: HTMLInputElement }) {
    emit('updateSelect', event.target.id, event.target.value)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _createTextVNode(_toDisplayString(_ctx.$t('common.SELECTS.ORDER_BY.LABEL')) + ": ", 1),
      _createElementVNode("select", {
        name: "order_by",
        id: "order_by",
        value: _unref(query).order_by,
        onChange: onSelectUpdate
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(order_by), (order) => {
          return (_openBlock(), _createElementBlock("option", {
            value: order,
            key: order
          }, _toDisplayString(_ctx.$t(`${_unref(message)}.${order.toUpperCase()}`)), 9, _hoisted_3))
        }), 128))
      ], 40, _hoisted_2)
    ]),
    _createElementVNode("label", null, [
      _createTextVNode(_toDisplayString(_ctx.$t('common.SELECTS.ORDER.LABEL')) + ": ", 1),
      _createElementVNode("select", {
        name: "order",
        id: "order",
        value: _unref(query).order,
        onChange: onSelectUpdate
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sort), (order) => {
          return (_openBlock(), _createElementBlock("option", {
            value: order,
            key: order
          }, _toDisplayString(_ctx.$t(`common.SELECTS.ORDER.${order.toUpperCase()}`)), 9, _hoisted_5))
        }), 128))
      ], 40, _hoisted_4)
    ]),
    _createElementVNode("label", null, [
      _createTextVNode(_toDisplayString(_ctx.$t('common.SELECTS.PER_PAGE.LABEL')) + ": ", 1),
      _createElementVNode("select", {
        name: "per_page",
        id: "per_page",
        value: _unref(query).per_page,
        onChange: onSelectUpdate
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(perPage, (nb) => {
          return _createElementVNode("option", {
            value: nb,
            key: nb
          }, _toDisplayString(nb), 9, _hoisted_7)
        }), 64))
      ], 40, _hoisted_6)
    ])
  ]))
}
}

})